"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __exports_1 = require("../../../__exports");
var CheckboxSection = function (props) {
    return (React.createElement(__exports_1.default.Panel, { paddingTop: 'Small' }, props.options &&
        props.options.map(function (option, index) {
            if (!option.isVisible)
                return null;
            return (React.createElement(__exports_1.default.Panel, { key: index, paddingBottom: 'Medium' },
                React.createElement(__exports_1.default.Checkbox, { id: option.id, key: index, label: option.label, showLabel: true, isChecked: option.isChecked, isEnabled: option.isEnabled, onChange: function (value) { return props.onCheckboxClick && props.onCheckboxClick(value, index, option); } })));
        })));
};
exports.default = CheckboxSection;
//# sourceMappingURL=CheckboxSection.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/filter-sections/build/control/components/CheckboxSection/CheckboxSection.js
// module id = 331
// module chunks = 0